import { lazy } from 'react';

import { IconKey } from './icon-key';
import { Icons } from './icons-map';

const lazyIcons = new Map<IconKey, ReturnType<typeof lazy>>();

function getLazyIcon(icon: IconKey) {
	let component = lazyIcons.get(icon);

	if (!component) {
		component = lazy(() =>
			Icons[icon as keyof typeof Icons]().then((Component) => ({
				default: Component,
			}))
		);

		lazyIcons.set(icon, component);
	}

	return component;
}

export function getIcon(icon: IconKey): ReturnType<typeof lazy> | undefined;
export function getIcon(icon: IconKey | undefined | null, fallback: IconKey): ReturnType<typeof lazy>;

/**
 * Gets a lazy loaded icon component by its key.
 * If the icon key is not found or is undefined/null, the fallback icon key is used.
 *
 * @param icon - The icon key to get.
 * @param fallback - The fallback icon key to use if the icon key is not found.
 * @returns The lazy icon component.
 */
export function getIcon(icon: IconKey | undefined | null, fallback?: IconKey): ReturnType<typeof lazy> | undefined {
	const resolved = icon && icon in Icons ? icon : fallback;
	return resolved ? getLazyIcon(resolved) : undefined;
}
